import { useEffect, useState } from 'react';
export default function useStateControl(value) {
    const [currentValue, setCurrentValue] = useState(value);
    useEffect(() => {
        setCurrentValue(value);
    }, [value]);
    return [currentValue, setCurrentValue];
}
